import { createSelector } from '@ngrx/store';

import { getBecomeACustomerState } from '../../become-a-customer-feature.selector';

export const getIsCustomer = createSelector(
  getBecomeACustomerState,
  (state) => state.isCustomer.isCustomer
);
